import SharedPropsService from '../../../SharedPropsService';
import { ButtonTypeTokens, StepperStateToken, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import _ from 'lodash';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import { AnalyticsEventTracker, } from '../../../configs/constants';
import { nextStepCredStepper } from '../../../configs/utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
let hasNavigated = false;
let t_and_c_1 = true;
let t_and_c_2 = true;
export const verifyKycSummary = async (action, _datastore, { network, setDatastore, showPopup, analytics, instrumentTrack, navigateWithClear }) => {
    instrumentTrack('KYC_SUMMARY_CONFIRM_BUTTON_CLICKED');
    await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', {
        loading: true,
    });
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const response = await network.get(`${api.kycSummaryVerify}${applicationId}`, { headers: await getAppHeader() });
    if (_.get(response, 'data.updatedApplicationObj.currentStepId', false)) {
        const user = await SharedPropsService.getUser();
        user.linkedApplications[0].stepStatusMap.KYC_SUMMARY =
            StepperStateToken.COMPLETED;
        user.linkedApplications[0].stepStatusMap.KYC_AADHAAR_VERIFICATION =
            StepperStateToken.COMPLETED;
        user.linkedApplications[0].stepStatusMap.KYC_PHOTO_VERIFICATION =
            StepperStateToken.COMPLETED;
        user.linkedApplications[0].stepStatusMap.BANK_ACCOUNT_VERIFICATION =
            StepperStateToken.IN_PROGRESS;
        user.linkedApplications[0].currentStepId = _.get(response, 'data.updatedApplicationObj.currentStepId');
        await SharedPropsService.setUser(user);
        analytics(AnalyticsEventTracker.borrower_kyc_complete['Event Name'], {
            ...AnalyticsEventTracker.borrower_kyc_complete,
        });
        const routeObj = await nextStepCredStepper(user.linkedApplications[0].currentStepId);
        setTimeout(() => {
            !hasNavigated && navigateWithClear(routeObj.routeId, routeObj.params);
        }, 3000);
        await setDatastore(ROUTE.KYC_SUMMARY, "kycSummaryPage", {
            showSuccess: true
        });
        // await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', <ButtonProps>{
        //     loading: false,
        // })
    }
};
export const updateKyc = async (action, _datastore, { network, setDatastore, showPopup, analytics, instrumentTrack, navigateWithClear }) => {
    await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', {
        loading: true,
    });
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const response = await network.post(`${api.updateKyc}${applicationId}`, {}, { headers: await getAppHeader() });
    await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', {
        loading: false,
    });
    if (_.get(response, 'data.currentStepId', false)) {
        const user = await SharedPropsService.getUser();
        user.linkedApplications[0].currentStepId = _.get(response, 'data.currentStepId');
        await SharedPropsService.setUser(user);
        analytics(AnalyticsEventTracker.borrower_kyc_complete['Event Name'], {
            ...AnalyticsEventTracker.borrower_kyc_complete,
        });
        const routeObj = await nextStepCredStepper(user.linkedApplications[0].currentStepId);
        !hasNavigated && navigateWithClear(routeObj.routeId, routeObj.params);
        await setDatastore(ROUTE.KYC_SUMMARY, "kycSummaryPage", {
            showSuccess: true
        });
    }
};
export const NavigateNext = async (action, _datastore, { navigateWithClear }) => {
    hasNavigated = true;
    const routeObj = await nextStepCredStepper();
    console.log('Next object received is', routeObj);
    navigateWithClear(routeObj.routeId, routeObj.params);
};
export const GoBackAction = async (action, _datastore, { goBack, navigate }) => {
    t_and_c_1 = true;
    t_and_c_2 = true;
    await navigate(ROUTE.KYC_STEPPER);
};
export const ToggleKYCSummaryCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.KYC_SUMMARY, 'continue', {
        type: action.payload.value
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const ToggleKYCSummaryCTA_Action = async (action, _datastore, { setDatastore }) => {
    const widgetId = action?.payload?.widgetId;
    switch (widgetId) {
        case 'radio1':
            t_and_c_1 = !t_and_c_1;
            await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', { radioButton1Check: t_and_c_1 });
            break;
        case 'radio2':
            t_and_c_2 = !t_and_c_2;
            await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', { radioButton2Check: t_and_c_2 });
            break;
    }
    if (t_and_c_1 === false) {
        await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', {
            disableCTA: true
        });
    }
    else {
        await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', {
            disableCTA: false
        });
    }
    if (t_and_c_1 && t_and_c_2) {
        await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', {
            disableCTA: false
        });
    }
    else {
        await setDatastore(ROUTE.KYC_SUMMARY, 'kycSummaryPage', {
            disableCTA: true
        });
    }
};
export const needHelpAction = async (action, datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const onLoadAction = async (action, _datastore, { goBack, navigate }) => {
    t_and_c_1 = true;
    t_and_c_2 = true;
};
